<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Vendedores</h1>
          <p class="view-header__subtitle">Administrá los vendedores y sus comisiones.</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="newSalesClerk">
            <i class="bi bi-person-plus"></i>
            Nuevo vendedor
          </button>
        </div>
      </div>
    </div>

    <!-- STATS -->
    <div class="row">
      <div class="col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoMoneda2Dec(comtotales) }}</div>
          <div class="stats-card__label">Comisiones totales este mes</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoMoneda2Dec(comliqui) }}</div>
          <div class="stats-card__label">Comisiones liquidadas</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoMoneda2Dec(comsinliqui) }}</div>
          <div class="stats-card__label">Comisiones sin liquidar</div>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar vendedor...">
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @salesClerkDetail="getSalesClerkDetail"
        @edit="editSalesClerk"
        @delete="deleteSalesClerk"
      />
    </div>

    <!-- MODAL NUEVO / EDITAR VENDEDOR -->
    <NuevoVendedor
      v-if="showModal"
      :salesClerkId="salesClerkIdParent"
      @confirmsave="onSaved"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import NuevoVendedor from './Nuevo-vendedor.vue';
import formatMoneyMixin from "./../../../mixins/formatMoneyMixin";

export default {
  components: {
    VdtnetTable,
    NuevoVendedor,
  },
  mixins: [formatMoneyMixin],
  data: function () {
    return {
      comtotales: 0,
      comliqui: 0,
      comsinliqui: 0,
      doSearch: '',
      isLoading: false,
      showModal: false,
      salesClerkIdParent: null,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/salesclerks/list",
          type: "GET",
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: false,
        pageLength: 15,
        searching: true,
        searchDelay: 500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        autoWidth: false,
      },
      fields: {
        id: { label: 'Código', width: '80px', sortable: false },
        name: {
          label: 'Nombre',
          sortable: false,
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data}</span>` : data,
        },
        phone: { label: 'Teléfono', width: '130px', sortable: false },
        com_sales: {
          label: 'Comisión venta',
          width: '120px',
          align: 'right',
          sortable: false,
          render: (data) => `${data} %`,
        },
        com_payment: {
          label: 'Comisión cobro',
          width: '120px',
          align: 'right',
          sortable: false,
          render: (data) => `${data} %`,
        },
        use_rules: {
          label: 'Reglas',
          width: '130px',
          align: 'center',
          sortable: false,
          render: (data, type) => {
            if (type !== 'display') return data;
            const hasRules = Number(data) === 1 || data === true;
            return hasRules
              ? '<span class="status-badge status-badge--success">Personalizadas</span>'
              : '<span class="status-badge status-badge--neutral">Estándar</span>';
          },
        },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "130px",
          align: "right",
          defaultContent: `
            <div class="table-action-group">
              <button data-action="salesClerkDetail" class="table-action-btn" type="button" title="Ver detalle">
                <i class="bi bi-eye"></i>
              </button>
              <button data-action="edit" class="table-action-btn" type="button" title="Editar">
                <i class="bi bi-pencil"></i>
              </button>
              <button data-action="delete" class="table-action-btn" type="button" title="Eliminar">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          `,
        },
      },
    };
  },
  mounted() {
    this.getIndex();
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.isLoading = true; });
      dt.on('xhr.dt', () => { this.isLoading = false; });
    });
  },
  created() {
    this.$store.dispatch('salesClerks/getSalesclerks');
  },
  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === '' && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    newSalesClerk() {
      this.salesClerkIdParent = null;
      this.showModal = true;
    },
    editSalesClerk(data) {
      this.salesClerkIdParent = data.id;
      this.showModal = true;
    },
    onSaved() {
      this.refreshTable();
      this.getIndex();
      this.$store.dispatch('salesClerks/getSalesclerks');
    },
    getSalesClerkDetail(data) {
      this.$router.push({ name: 'Detalle de vendedor', params: { salesClerkId: data.id } });
    },
    getIndex() {
      this.$http.post("/api/salesclerks/getIndex").then((response) => {
        this.comtotales = response.data.total;
        this.comliqui = response.data.debt;
        this.comsinliqui = response.data.paid;
      });
    },
    deleteSalesClerk(data) {
      if (!confirm("¿Está seguro que desea borrar este vendedor?")) return;
      this.$http.post("/api/salesclerks/delete", { id: data.id }).then((response) => {
        if (response.data.code === 201) {
          this.refreshTable();
          this.$store.dispatch('salesClerks/getSalesclerks');
        }
      });
    },
  },
};
</script>
